import React from 'react'
import { CommonPopup } from 'common/components/entities/popup-new'
import { PopupInterface } from 'common/types/entities/popup-interface'
import BaseNodeChildren from 'publisher/components/ChildrenEntities'

export interface NewPopupProps {
  entity: PopupInterface
  closePopup: () => void
  overflow?: string
  maxHeight?: string
}

export const PopupNew = ({ entity, closePopup }: NewPopupProps) => {
  return (
    <CommonPopup
      entity={entity}
      onCloseHandler={closePopup}
      showClose={entity.showClose}
      maxHeight={'calc(100vh - 40px)'}
    >
      {!!entity?.childIds?.length && (
        <BaseNodeChildren childIds={entity.childIds} />
      )}
    </CommonPopup>
  )
}
